define(function(require, exports, module) {
    'use strict';

    var Class = require('Class');
    var $ = require('j');
    var Backbone = require('backbone');

    require('widgets/animation.widget');

    var _animationConfig = {
        animationsMap: {
            menu__navigation: ['slideLineMenu']
        }
    };
    var _animatedClasses = ['menu__navigation'];
    var _animatedElsSelector = '.menu__navigation';

    module.exports = Class.create({

        _configTemplate: {
            animationsMap: {
                // menu slider
                'menu__navigation': ['slideLineMenu']
            }
        },

        initialize: function() {
            this._patchJBone();

            $('body').on('animation', this.attachAnimation.bind(this));
        },

        _patchJBone: function() {
            var patchAnimations = function(originalFnName) {
                var originalFn = $.fn[originalFnName];
                var preservedFnName = 'original' + originalFnName[0].toUpperCase() + originalFnName.substring(1);
                $.fn[preservedFnName] = originalFn;

                $.fn[originalFnName] = function() {
                    var result = originalFn.apply(this, arguments);
                    var event = {type: 'animation', data: this};
                    $('body').trigger($.Event(event));
                    return result;
                };
            };

            var fnNames = [
              'append',
              'addClass',
              'removeClass',
              'removeClasses',
              'toggleClass'
            ];

            fnNames.forEach(patchAnimations);
        },

        attachAnimation: function(event) {
            var animatedEls = event.data.find(_animatedElsSelector);
            var elAnimationsMap = [];

            animatedEls.forEach(function(el) {
                if ($.isWidgetAttached(el, 'animation')) {
                    return;
                }

                var elAnimations = {
                    el: el,
                    animations: []
                };

                _animatedClasses.forEach(function(animationClass) {
                    if (el.classList.contains(animationClass)) {
                        var animations = Object.values(_animationConfig.animationsMap);

                        elAnimations.animations = elAnimations.animations.concat(animations);
                    }
                });

                if (elAnimations.animations.length) {
                    elAnimationsMap.push(elAnimations);
                }
            });

            elAnimationsMap.forEach(function(elAnimations) {
                $(elAnimations.el).animation(elAnimations.animations);
            });

        }

    }, Backbone.Events);
});
